(function () {
  if (window.__zenithImageGallery) return;
  window.__zenithImageGallery = true;

  const MOBILE_MQL = window.matchMedia("(max-width: 749px)");

  function initGalleries(root = document) {
    const elements = root.querySelectorAll(".image-gallery__wrapper");

    elements.forEach((el) => {
      const blockCount = parseInt(el.dataset.blockCount, 10) || 0;

      if (!MOBILE_MQL.matches || blockCount <= 1) {
        if (el.swiper) el.swiper.destroy(true, true);
        return;
      }

      if (el.swiper) return;

      new Swiper(el, {
        wrapperClass: "image-gallery__grid",
        slideClass: "image-gallery__image",
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 500,
        rewind: true,
        pagination: {
          el: el.querySelector(".image-gallery__pagination"),
          clickable: true,
        },
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initGalleries());
  } else {
    initGalleries();
  }

  MOBILE_MQL.addEventListener("change", () => initGalleries());

  document.addEventListener("shopify:section:load", (e) => {
    initGalleries(e.target);
  });
})();
